export default [
  // { title: 'About', to: '#!' },
  // { title: 'Contact', to: '#!' },
  // { title: 'Careers', to: '#!' },
  // { title: 'Blog', to: '#!' },
  // { title: 'Terms', to: '#!' },
  { title: 'SMSTerms', to: '/smsterms' },
  { title: 'Privacy', to: '/privacypolicy' }
];
